import { css } from 'twin.macro';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Tab, Tabs } from 'react-bootstrap';
import FileSaver from 'file-saver';
import { FormPdf } from '../../_elements/FormPdf';
import StaticPreview from '@/components/Admin/Form/StaticPreview';
import { VscLoading } from 'react-icons/vsc';
import FormPdfPreview from './FormPdfPreview';

const SelectedOptionsView = ({
    formData,
    form,
    canDownload,
    canDownloadPDF = () => {},
    handleCloseModal = () => {},
}) => {
    const [key, setKey] = useState('pdf');
    const [isDownloading, setIsDownloading] = useState(false);

    const generatePdfAndDownload = async (singleFile = true) => {
        setIsDownloading(true);
        try {
            if (singleFile) {
                const blob = await FormPdf([form], 'combined', { hideUnselectedOptions: true, hideInstruction: true });
                return FileSaver.saveAs(
                    blob,
                    `${form?.formData?.name || 'submittedForm'}_${form?.userData?.name || 'user'}.pdf`
                );
            }
        } catch (error) {
            console.log('ERROR IN PDF GENERATION => ', error);
        } finally {
            setIsDownloading(false);
        }
    };
    return (
        <Fragment>
            {(canDownload || canDownloadPDF()) && (
                <div>
                    <div className="d-flex justify-content-end">
                        <button
                            onClick={() => generatePdfAndDownload()}
                            disabled={isDownloading}
                            className="btn btn-info float-right border border-white btn-lg mb-2"
                        >
                            {isDownloading && <VscLoading className="spin mr-2" />}
                            {isDownloading ? 'Downloading...' : 'Download Completed Fields PDF'}
                        </button>
                    </div>
                </div>
            )}
            <FormPdfPreview form={form} hideUnselectedOptions={true} hideInstruction={true} />
            {/* <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
                css={css`
                    .active {
                        .tab-title {
                            color: #495057 !important;
                        }
                    }
                `}
            >
                <Tab eventKey="staticform" title={<span className="tab-title">Completed: Static Form</span>}>
                    {key === 'staticform' && (
                        <StaticPreview
                            formElements={formData}
                            onlyView={true}
                            isPreview={true}
                            userFormData={form || {}}
                            handleCloseModal={handleCloseModal}
                            isDraft={false}
                        />
                    )}
                </Tab>
                {(canDownload || canDownloadPDF()) && (
                    <Tab eventKey="pdf" title={<span className="tab-title">Completed: PDF</span>}>
                        {key === 'pdf' && (
                            <div
                                css={css`
                                    height: 70vh;
                                    overflow: auto;
                                `}
                            >
                                <PDFViewer
                                    width="100%"
                                    height="100%"
                                    css={css`
                                        border: none;
                                        outline: none;
                                    `}
                                    showToolbar={false}
                                >
                                    {FormPdf(form, 'component', { onlySelectedFields: true })}
                                </PDFViewer>
                            </div>
                        )}
                    </Tab>
                )}
            </Tabs> */}
        </Fragment>
    );
};

export default SelectedOptionsView;
